import { Block, CircleLoader } from "@stepapp/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useCallback, useEffect } from "react";
import { useIsNavReady } from "../../src/hooks";

const DismissBrowserScreen = () => {
  const { push } = useRouter();
  const isNavReady = useIsNavReady();
  const { returnUrl } = useLocalSearchParams();

  const handleClosePage = useCallback(() => {
    if (returnUrl) {
      push(returnUrl as `${string}:${string}`);
    }
  }, [returnUrl, push]);

  useEffect(() => {
    if (!isNavReady) return;

    handleClosePage();
  }, [handleClosePage, isNavReady]);

  return (
    <Block alignCenter marginTop={10}>
      <CircleLoader />
    </Block>
  );
};

export default DismissBrowserScreen;
